<template>
  <modal
    name="tech-support-release-detail"
    :width="960"
    :height="'86%'"
    :adaptive="true"
    :scrollable="false"
    class="release-detail-modal"
    @closed="$emit('closed')"
  >
    <section class="release-detail" aria-labelledby="release-detail-title">
      <app-modal-header
        design="new"
        :eyebrow="language === 'ru' ? 'Полный релиз' : 'Full release'"
        :title="release ? release.title : loadingTitle"
        title-id="release-detail-title"
        @close="$modal.hide('tech-support-release-detail')"
      />

      <div class="release-detail__body">
        <div v-if="loading" class="release-detail__loading">
          <app-spinner design="new" />
        </div>
        <div v-else-if="error" class="release-detail__error" role="alert">
          <strong>{{ language === 'ru' ? 'Не удалось загрузить релиз' : 'Unable to load this release' }}</strong>
          <p>{{ error }}</p>
          <app-button design="new" theme="dark" @click.native="$emit('retry')">
            {{ language === 'ru' ? 'Повторить' : 'Retry' }}
          </app-button>
        </div>
        <release-preview
          v-else-if="release"
          :release="release"
          :language="language"
          class="release-detail__preview"
        />
      </div>
    </section>
  </modal>
</template>

<script>
import ReleasePreview from './ReleasePreview'

export default {
  name: 'TechSupportReleaseDetailModal',
  components: { ReleasePreview },
  props: {
    error: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'en'
    },
    loading: {
      type: Boolean,
      default: false
    },
    release: {
      type: Object,
      default: null
    }
  },
  computed: {
    loadingTitle() {
      return this.language === 'ru' ? 'Загрузка релиза…' : 'Loading release…'
    }
  }
}
</script>

<style lang="scss">
.release-detail-modal > .vm--modal {
  height: 86% !important;
  overflow: hidden !important;
}

.release-detail {
  display: flex;
  height: 100%;
  flex-direction: column;
  background-color: $ui-surface-soft;
  color: $ui-text;
  font-family: $ui-font-body;
}

.release-detail__body {
  min-height: 0;
  flex: 1;
  padding: $ui-space-20 $ui-space-24 $ui-space-24;
  overflow-y: auto;
}

.release-detail__loading,
.release-detail__error {
  display: flex;
  min-height: 240px;
  align-items: center;
  justify-content: center;
}

.release-detail__error {
  flex-direction: column;
  gap: $ui-space-12;
  text-align: center;
}

.release-detail__error strong {
  color: $ui-ink;
  font-family: $ui-font-heading;
  font-size: $ui-font-size-entity-title;
}

.release-detail__error p {
  margin: 0;
  color: $ui-red;
}

.release-detail__preview {
  box-shadow: none;
}

@media (max-width: 760px) {
  .release-detail__body {
    padding: $ui-space-12;
  }
}
</style>
